<div class="account-pages mt-5 mb-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="text-center">
          <a href="/" class="mb-4 d-block auth-logo">
            <img src="https://pagos-facturas.s3.amazonaws.com/Imagenes/tecsa.png" alt="logo-dark"
              class="logo logo-dark img-fluid">
            <img src="https://pagos-facturas.s3.amazonaws.com/Imagenes/tecsa.png" alt="logo-light"
              class="logo logo-light img-fluid">
          </a>
        </div>
      </div>
    </div>
    <div class="row align-items-center justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden background-login">
          <div class="card-body p-4" style="background-color: #000 !important;">
            <div class="text-center mt-2">
              <h5 class="greens">¡Bienvenido de vuelta!</h5>
              <p class="text-muted text-white">Inicia sesión para ingresar al sistema</p>
            </div>
            <div class="p-2 mt-4">
              <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                @if(error)
                { <ngb-alert type="danger" [dismissible]="false">{{ error }}</ngb-alert>
                }
                <div class="mb-3">
                  <label for="email" class="text-white">Usuario</label>
                  <input type="email" formControlName="username" class="form-control" id="email" placeholder="Email"
                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                  @if(submitted && f.username.errors){
                  <div class="invalid-feedback">
                    @if(f.username.errors.required){
                    <div>Email is required</div>
                    }@if(f.username.errors.username){
                    <div>Email must be a valid email address</div>
                    }
                  </div>}
                </div>

                <div class="mb-3">
                  <div class="float-end">
                    <a [routerLink]="['/account/auth/request-change']" class="text-gray">¿Olvidaste tu contraseña?</a>
                  </div>

                  <label for="password" class="text-white">Contraseña</label>
                  <div class="form-group position-relative">
                    <input required="" formControlName="password" [type]="type" class="form-control"
                      placeholder="Contraseña" autocomplete="current-password">
                    <span *ngIf="type == 'password'" class="eyeButton" (click)="myFunctionPasswordCurrent()" matSuffix>
                      <i class="fa fa-eye"></i>
                    </span>
                    <span *ngIf="type == 'text'" class="eyeButton" (click)="myFunctionPasswordCurrent()" matSuffix>
                      <i class="fa fa-eye-slash"></i>
                    </span>
                    @if(submitted && f.email.errors){
                    <div class="invalid-feedback">
                      @if(f.email.errors.required){
                      <div>Password is required</div>}
                    </div>}
                  </div>
                </div>
                <div class="mt-3 text-end">
                  <button class="btn w-sm waves-effect waves-light buttonSubmit blueButton"
                    [disabled]="loginForm.invalid" type="submit" style="width: 40%;">
                    <dx-load-indicator *ngIf="loading" id="small-indicator" height="20"
                      width="20"></dx-load-indicator>{{textLogin}}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="mt-5 text-center">
          <p>Copyright {{year}} © TECSA All rights reserved.</p>
        </div>
      </div>
    </div>
  </div>


  <ng-template #StaticDataModal let-modal>
    <ng-container *ngIf="showModalContrasena">
      <div class="row">
        <div class="col-lg-12">
          <div class="card border border-warning" style="background-color: #000;">
            <div class="card-header bg-transparent border-warning p-3">
              <h3 class="my-0 text-warning"><i class="fa fa-exclamation-triangle me-3"></i>Actualización de Datos</h3>
            </div>
            <div class="card-body">
              <h5 class="mt-0" style="font-size: 17px; color: white;">
                Hemos identificado que posiblemente tu contraseña no está actualizado en nuestro sistema.
                Te invitamos a actualizarla en este momento.
              </h5>
              <p class="card-text" style="font-size: 17px; margin-top: 2%;">
                Tu correo actual es: {{correoUsuarioMasked }}<br>
              </p>
              <div class="modal-footer">
                <button type="button" class="btn btn-warning" data-bs-toggle="modal" data-bs-target="#exampleModal"
                  data-bs-whatever="@getbootstrap" (click)="MaryModal(); modal.dismiss('Close click')">
                  Actualizar Contraseña
                </button>
                <!-- <button type="button" class="btn btn-warning waves-effect" data-bs-dismiss="modal"
                  (click)="modal.close('Close click')">Close</button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #largeDataModal let-modal>
    <div class="row">
      <div class="col-lg-12">
        <div class="card border">
          <div class="card-header bg-transparent border-secondary p-3" style="background-color: aliceblue;">
            <h3 class="my-0 text-link">
              <i class="fa fa-lock me-3"></i>Actualizar Contraseña
            </h3>
          </div>
          <div class="modal-body">
            <form (ngSubmit)="onFormSubmitPassword($event)">
              <div class="tab-content p-1">
                <div class="tab-pane active">
                  <ul class="activity-feed mb-0 ps-0">
                    <li class="feed-item">
                      <div class="feed-item-list">
                        <h5 class="font-size-16">Actual Contraseña: </h5>
                        <div class="col-md-12 position-relative">
                          <input class="form-control" [type]="type" placeholder="Ingrese su contraseña actual"
                            [(ngModel)]="formPassword.password" name="password"
                            pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$" required>
                          <span *ngIf="type == 'password'" class="eyeButtons" (click)="myFunctionPasswordCurrent()">
                            <i class="fa fa-eye"></i>
                          </span>
                          <span *ngIf="type == 'text'" class="eyeButtons" (click)="myFunctionPasswordCurrent()">
                            <i class="fa fa-eye-slash"></i>
                          </span>
                        </div>
                      </div>
                    </li>
                    <li class="feed-item">
                      <div class="feed-item-list">
                        <h5 class="font-size-16">Nueva Contraseña: </h5>
                        <div class="col-md-12 position-relative">
                          <input (keyup)="onPasswordInput($event)" class="form-control" [type]="type2"
                            placeholder="Ingrese su nueva contraseña" [(ngModel)]="formPassword.newPassword"
                            name="newPassword"
                            pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[^\w\s]).{6,16}$" required>
                          <span *ngIf="type2 == 'password'" class="eyeButtons" (click)="myFunctionPasswordConfirm()"
                            matSuffix>
                            <i class="fa fa-eye"></i>
                          </span>
                          <span *ngIf="type2 == 'text'" class="eyeButtons" (click)="myFunctionPasswordConfirm()"
                            matSuffix>
                            <i class="fa fa-eye-slash"></i>
                          </span>
                        </div>
                      </div>
                    </li>
                    <li class="feed-item">
                      <div class="feed-item-list">
                        <h5 class="font-size-16">Confirmar Contraseña: </h5>
                        <div class="col-md-12 position-relative">
                          <input (keyup)="checkPasswordsMatch()" class="form-control" [type]="type3"
                            placeholder="Confirme su nueva contraseña" [(ngModel)]="formPassword.confirmPassword"
                            name="confirmPassword" required>
                          <span *ngIf="type3 == 'password'" class="eyeButtons" (click)="myFunctionPasswordConfirmNew()"
                            matSuffix>
                            <i class="fa fa-eye"></i>
                          </span>
                          <span *ngIf="type3 == 'text'" class="eyeButtons" (click)="myFunctionPasswordConfirmNew()"
                            matSuffix>
                            <i class="fa fa-eye-slash"></i>
                          </span>
                        </div>
                        <span [@fadeInUp] class="text-danger"
                          *ngIf="formPassword.newPassword && formPassword.confirmPassword && formPassword.newPassword !== formPassword.confirmPassword">
                          Las contraseñas no coinciden.
                        </span>
                        <!--
                      <span [@fadeInUp] class="text-success" *ngIf="formPassword.newPassword && formPassword.confirmPassword && formPassword.newPassword === formPassword.confirmPassword">
                        Las contraseñas coinciden.
                      </span>
                      -->
                      </div>
                      <div class="mt-3 password-requirements">
                        <p class="mb-0 text-data">
                          <i class="fa fa-check-circle" [ngClass]="{ checked: minCaracteres && maxCaracteres }"
                            aria-hidden="true"></i>
                          La contraseña debe tener más de 6 caracteres y menos de 16.
                        </p>
                        <p class="mb-0 text-data">
                          <i class="fa fa-check-circle" [ngClass]="{ checked: hasMayus && hasMinus }"
                            aria-hidden="true"></i>
                          Al menos una mayúscula y minúsculas.
                        </p>
                        <p class="mb-0 text-data">
                          <i class="fa fa-check-circle" [ngClass]="{ checked: espCaracter }" aria-hidden="true"></i>
                          Un caracter no alfanumérico (ejemplo: #?!&).
                        </p>
                        <p class="mb-0 text-data">
                          <i class="fa fa-check-circle" [ngClass]="{ checked: hasNumber }" aria-hidden="true"></i>
                          Un número.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button [disabled]="
                    !formPassword.password || 
                    !formPassword.newPassword || 
                    !formPassword.confirmPassword || 
                    formPassword.newPassword !== formPassword.confirmPassword || 
                    formPasswordLoader
                  " class="btn continuar buttonSubmit mb-1 w-50" id="greenAlta" type="submit"
              (click)="onFormSubmitPassword($event, modal)">
              <!-- <dx-load-indicator *ngIf="loadingTwo" id="small-indicator" height="20" width="20"></dx-load-indicator> -->
              <i class="fa fa-check" *ngIf="!loadingTwo"></i><span>{{submitTwo}}</span>
            </button>
          </div>
        </div>
      </div>
      <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingTwo" [showIndicator]="true"
        [showPane]="true" [shading]="true" [closeOnOutsideClick]="false" [message]="'Cargando...'">
      </dx-load-panel>
    </div>
  </ng-template>